<template>
  <div class="popup_in">
    <div class="whatsapp-popup popup">
      <!-- X button -->
      <div class="popup_close close-animate">
        <a href="javascript:void(0);" @click="$emit('close')"><close-svg /></a>
      </div>
      <!-- Message SVG -->
      <img class="svg" src="/assets/img/svg/alert.svg" />
      <div>
        <div class="whatsapp-title title">
          לתשומת ליבך
          <div class="shrink-font marg-top">
            הנך מועבר למערכת וואטסאפ אישית שאינה מאובטחת ואינה מתועדת. מומלץ
            לשמור על כללי אבטחת מידע מתאימים.
          </div>
        </div>
      </div>
      <div class="flex flex--content--center flex-buttons">
        <a class="whatsapp-cancel-btn" @click.prevent="closePopup">בטל</a>
        <a class="whatsapp-send-btn bt_blue" @click.prevent="onApprove"
          >הבנתי, המשך</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import CloseSvg from "@/assets/img/svg/close-sm.svg";
import { isApplication } from "../../utilities/globals";

export default {
  data() {
    return {
      didSubmit: false
    };
  },
  props: {
    patientPhone: {
      required: true,
      type: String
    }
  },
  mounted() {
    window.addEventListener("keydown", this.handleKeyDown);
  },
  beforeUnmount() {
    window.removeEventListener("keydown", this.handleKeyDown);
  },
  methods: {
    onApprove() {
      if (isApplication()) {
        const element = document.createElement("a");
        element.href = `whatsapp:${this.patientPhone}`;
        element.target = "_blank";
        element.click();
      } else {
        window.open(
          `https://wa.me/+972${this.patientPhone.slice(1)}`,
          "_blank",
          "noreferrer"
        );
      }
      this.closePopup();
    },
    closePopup() {
      this.$emit("close");
    },
    handleKeyDown(e) {
      if (e.key === "Escape") this.closePopup();
    }
  },
  computed: {},
  components: {
    CloseSvg
  }
};
</script>

<style scoped>
.whatsapp-popup {
  background-color: #fff;
  max-width: 666px;
  border-radius: 15px;
}
.whatsapp-title {
  color: #324997;
  font-size: 42px;
  font-weight: 700;
}
.flex-buttons {
  gap: 13px;
  margin-top: 27px;
  flex-direction: column-reverse;
}
.svg {
  width: 42px;
}
.shrink-font {
  line-height: 1.1;
  font-size: 28px;
  font-weight: 300;
}
.marg-top {
  margin-top: 20px;
}
.whatsapp-cancel-btn {
  text-decoration: underline;
  cursor: pointer;
}
.whatsapp-cancel-btn:hover {
  opacity: 0.75;
}
.whatsapp-send-btn {
  margin-top: 20px;
  min-width: 233px;
  border-radius: 5px;
  text-decoration: none;
  height: 58px;
  line-height: 55px;
}
@media only screen and (max-width: 1200px) {
  .whatsapp-title {
    color: #324997;
    font-size: 28px;
    font-weight: 700;
    margin-bottom: 20px;
  }
  .shrink-font {
    display: block;
    font-size: 24px;
  }
  .flex-buttons {
    flex-direction: column-reverse;
    gap: 10px;
  }
}
</style>
